// using a currency library here in case we want to add more in future
export const formatDollarAmount = (num: number | undefined, digits = 2, round = true) => {
  if (num !== undefined && num <= 0) return '$0.00'
  if (!num) return '-'
  if (num < 0.001 && digits <= 3) {
    return '<$0.001'
  }

  return Intl.NumberFormat('en-US', {
    notation: round ? 'compact' : 'standard',
    minimumFractionDigits: num > 1000 ? 2 : digits,
    maximumFractionDigits: num > 1000 ? 2 : digits,
  }).format(num)
}

// using a currency library here in case we want to add more in future
export const formatAmount = (num: number | undefined, digits = 2) => {
  if (num !== undefined && num <= 0) return '0'
  if (!num) return '-'
  if (num < 0.001) {
    return '<0.001'
  }

  return Intl.NumberFormat('en-US', {
    notation: 'compact',
    minimumFractionDigits: num > 1000 ? 2 : digits,
    maximumFractionDigits: num > 1000 ? 2 : digits,
  }).format(num)
}

export const getMonthName = (monthNumber) => {
  const date = new Date(0, monthNumber - 1)
  return date.toLocaleString('default', { month: 'long' })
}

function generateExcel(data: any[]): string {
  let excelContent = '<table>'

  // Generate table header
  const headers = Object.keys(data[0])
  excelContent += '<tr>'
  headers.forEach((header) => {
    excelContent += `<th>${header}</th>`
  })
  excelContent += '</tr>'

  // Generate table body
  data.forEach((row) => {
    excelContent += '<tr>'
    headers.forEach((header) => {
      excelContent += `<td>${row[header]}</td>`
    })
    excelContent += '</tr>'
  })

  excelContent += '</table>'
  return excelContent
}

export function downloadExcel(data: any[], fileName: string) {
  const excelContent = generateExcel(data)

  // Create a blob with the Excel content
  const blob = new Blob([excelContent], { type: 'application/vnd.ms-excel' })

  // Create a link element
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)

  // Set the file name
  link.download = `${fileName}.xls`
  document.body.appendChild(link)

  link.click()
  document.body.removeChild(link)
}
